/** @file Login view. */
import { loginWithEmail, loginWithGoogle, mapAuthError } from "../../persistence/auth.js";
import { navigate } from "../../core/router.js";
import { h, clear } from "../dom.js";

/**
 * @param {HTMLElement} host
 */
export function mountLoginView(host) {
  clear(host);

  const emailInput = h("input", {
    type: "email",
    name: "email",
    autocomplete: "email",
    required: true,
    class: "hb-auth-input",
  });
  const passwordInput = h("input", {
    type: "password",
    name: "password",
    autocomplete: "current-password",
    required: true,
    minLength: 6,
    class: "hb-auth-input",
  });
  const errorEl = h("div", { class: "text-sm text-red-400 min-h-5", role: "alert" });
  const submitBtn = h("button", { type: "submit", class: "hb-btn hb-btn--primary min-h-11 mt-2" }, [
    "Einloggen",
  ]);
  const form = h("form", { class: "flex flex-col gap-3" }, [
    h("label", { class: "flex flex-col gap-1 text-sm" }, [
      h("span", null, ["E-Mail"]),
      emailInput,
    ]),
    h("label", { class: "flex flex-col gap-1 text-sm" }, [
      h("span", null, ["Passwort"]),
      passwordInput,
    ]),
    submitBtn,
    errorEl,
  ]);

  const googleBtn = h(
    "button",
    { type: "button", class: "hb-btn min-h-11 w-full flex items-center justify-center gap-2" },
    ["Mit Google anmelden"],
  );

  const card = h(
    "div",
    {
      class:
        "hb-auth-card max-w-sm mx-auto mt-16 p-6 rounded-2xl bg-neutral-800 shadow-xl text-neutral-100",
    },
    [
      h("h1", { class: "text-2xl font-bold mb-4" }, ["Anmelden"]),
      form,
      h("div", { class: "flex gap-2 my-4 text-xs text-neutral-400 items-center" }, [
        h("span", { class: "flex-1 h-px bg-neutral-600" }),
        h("span", null, ["oder"]),
        h("span", { class: "flex-1 h-px bg-neutral-600" }),
      ]),
      googleBtn,
      h("div", { class: "flex justify-between mt-4 text-sm" }, [
        h("a", { href: "#/signup", class: "text-blue-400 hover:text-blue-300" }, ["Registrieren"]),
        h("a", { href: "#/reset", class: "text-blue-400 hover:text-blue-300" }, [
          "Passwort vergessen",
        ]),
      ]),
      h("div", { class: "text-center mt-4 text-sm" }, [
        h("a", { href: "#/help", class: "text-neutral-400 hover:text-neutral-200" }, [
          "Anleitung",
        ]),
      ]),
    ],
  );
  host.appendChild(card);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.textContent = "";
    try {
      await loginWithEmail(
        /** @type {HTMLInputElement} */ (emailInput).value,
        /** @type {HTMLInputElement} */ (passwordInput).value,
      );
      navigate("editor");
    } catch (err) {
      errorEl.textContent = mapAuthError(err);
    }
  });

  googleBtn.addEventListener("click", async () => {
    errorEl.textContent = "";
    try {
      await loginWithGoogle();
      navigate("editor");
    } catch (err) {
      errorEl.textContent = mapAuthError(err);
    }
  });
}
